import {atom} from 'recoil';

export const filterValuesState = atom({
  key: 'filterValuesState',
  default: {
    locationFilter: null,
    coordsFilter: {lat: null, lng: null},
    statusFilter: null,
    categoriesFilter: null,
    radiusFilter: null,
    pmProjectsOnlyFilter: false,
  },
});

export const savedProjectsFilterState = atom({
  key: 'savedProjectsFilterState',
  default: false,
});

// Which order contractor Open Jobs is in -- the "Newest / Closing soon"
// segmented control in the approved mockup. Lives here rather than in the
// header component because RequestForProposalsList builds the fetch URL, and
// the server does the ordering (sortBy + order), so flipping this has to
// rebuild the URL and refetch rather than re-sort the page already loaded.
export type OpenJobsSort = 'newest' | 'closingSoon';

export const openJobsSortState = atom<OpenJobsSort>({
  key: 'openJobsSortState',
  default: 'newest',
});
